import {Button, Col, Divider, Form, message, Row, Spin, Tag, Upload} from "antd";
import {
    ADMIN_NEEDED_DOCUMENT_LIST, ALLOWED_ALL_TYPES_TEXT,
    ALLOWED_DOCUMENT_TYPES,
    ALLOWED_IMAGE_TYPES,
    DOC_CODE_NIC_VERIFICATION_FRONT_DOC,
    DOC_CODE_NIC_VERIFICATION_REAR_DOC,
    DOC_CODE_PASSPORT_VERIFICATION_DOC,
    DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC,
    DOCUMENT_TYPES,
    IDENTIFICATION_SOURCE
} from "../../../util/Constants";
import {CheckCircleOutlined, CloseCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {DefaultDocumentDto} from "../../../dto/DefaultDocumentDto";
import {CustomerDetailWrapperDto} from "../../../dto/admin/CustomerDetailWrapperDto";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import {
    MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import documentService from "../../../service/documentService";
import {toNumber} from "lodash";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import CommonModalComp from "../../../components/common/preview/CommonModalComp";


interface DetailsAndDocumentVerificationInformationProps {
    customerDetailWrapperDto: CustomerDetailWrapperDto
}

enum SELECT_OPTION {
    YES = "1",
    NO = "0"
}

const DetailsAndDocumentVerificationInformation = (props: DetailsAndDocumentVerificationInformationProps) => {
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 10;

    const [nicFrontUploadedList, setNicFrontUploadedList] = useState<DefaultDocumentDto[]>()
    const [nicRearUploadedList, setNicRearUploadedList] = useState<DefaultDocumentDto[]>()
    const [passportAdminUploadedList, setPassportAdminUploadedList] = useState<DefaultDocumentDto[]>()
    const [pepUploadedList, setPepUploadedList] = useState<DefaultDocumentDto[]>()
    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [documentName, setDocumentName] = useState<string>("")
    const [isCanDisableForm, setCanDisableForm] = useState<boolean>(false);

    const [form] = Form.useForm();

    const normFile = (e: { fileList: any; }) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: ".pdf, .jpeg, .jpg,  .png"
    };
    useEffect(() => {
        fetchDocuments()
        setCustomerVerificationStatuses()
        setCanDisableForm("SYNC" !== props.customerDetailWrapperDto.customerMstDto.createdBy)

    }, []);
    const setCustomerVerificationStatuses = () => {
        let adminWorkBasketDto: WorkbasketTableDto = props.customerDetailWrapperDto.adminWorkBasketDto;
        if (adminWorkBasketDto) {
            form.setFieldsValue({
                coApproval: getBooleanByStatus(adminWorkBasketDto.complianceOfficerApproval),
                ceoApproval: getBooleanByStatus(adminWorkBasketDto.ceoApproval)
            })
        }
    }


    const getBooleanByStatus = (approval: string | undefined): boolean => {
        if (undefined !== approval) {
            return !!"Yes";
        }
        return false;
    }

    const fetchDocuments = () => {
        setSpinnerLoading(true);
        documentService.getUploadDocumentListByType(props.customerDetailWrapperDto?.customerMstDto?.id as number, ADMIN_NEEDED_DOCUMENT_LIST).then(res => {
            if (res.data !== null) {
                setDocuments(res.data.results)
                setSpinnerLoading(false);
            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
                setSpinnerLoading(false);


            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinnerLoading(false);
        })
    }

    const setDocuments = (documentList: [] | undefined) => {
        if (undefined != documentList) {
            documentList.map((document: any) => {
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;

                if (null != uploadDocumentDetailDto) {
                    let documentDto: DefaultDocumentDto = {
                        uid: uploadDocumentDetailDto.uploadDocumentDetailId.toString(),
                        url: uploadDocumentDetailDto.documentPath,
                        name: uploadDocumentDetailDto.originalDocumentName,
                        thumbUrl: uploadDocumentDetailDto.thumbB64
                    }

                    if (DOCUMENT_TYPES.NICVF === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({nicFrontDoc: documentDto})
                        setNicFrontUploadedList([documentDto])
                        // setAdminUploadedNicFrontDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.NICVR === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({nicRearDoc: documentDto})
                        setNicRearUploadedList([documentDto])
                        // setAdminUploadedRearFrontDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.PPV === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({passportDoc: documentDto})
                        setPassportAdminUploadedList([documentDto])
                        // setAdminUploadedPassportDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.PEP === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({pepDoc: documentDto})
                        setPepUploadedList([documentDto])
                        // setAdminUploadedPepDocument(uploadDocumentDetailDto)
                    }
                }
            })
        }
    };
    const openModal = (document: UploadedDocumentDetailDto | undefined, defaultDocument: DefaultDocumentDto | undefined) => {
        setIsModalOpen(false)
        setSpinnerLoading(true)
        let documentId: string = "";
        let documentName: string = "";
        if (undefined != defaultDocument) {
            documentId = defaultDocument.uid;
            documentName = defaultDocument.name
            // setSelectedDocumentId(undefined)
        } else if (undefined != document) {
            documentId = document.uploadDocumentDetailId.toString();
            documentName = document.originalDocumentName
            // setSelectedDocumentId(document.uploadDocumentDetailId)
        }
        viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setIsModalOpen(true)
                setDocumentName(documentName);
                setDocURL(res.data.results)
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinnerLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinnerLoading(false)
        })
        return true;
    };

    const viewOriginalDocument = (documentId: string) => {
        return documentService.viewOriginalDocument(documentId)
    }
    const onRemove = (file: any, code: string, docId: DOCUMENT_TYPES) => {
        setSpinnerLoading(true)
        documentService.deleteDocumentById(getUidByCode(docId)).then(res => {
            if (res.data !== null) {
                setSpinnerLoading(false)
                loadUploadedDocuments(props.customerDetailWrapperDto.customerMstDto?.id, [code])
            } else {
                setSpinnerLoading(false)
                message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })

        return true;
    };
    const loadUploadedDocuments = (jobNo: number | undefined, identityDocumentTypeCodeList: string[]) => {
        setSpinnerLoading(true)
        if (jobNo) {
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList(res.data.results)
                    setSpinnerLoading(false)
                } else {
                    setSpinnerLoading(false)
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                setSpinnerLoading(false)
                ErrorHandler.handleError(reason);
            })
        }

    };
    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        let defaultFileList: any;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.NICVF) {
            setNicFrontUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.NICVR) {
            setNicRearUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.PPV) {
            setPassportAdminUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.PEP) {
            setPepUploadedList(defaultFileList)
        }
    };


    const setUploadedDocumentList = (documents: any) => {
        documents.forEach((document: any) => {
            let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;
            createUploadedDocuments(uploadDocumentDetailDto, document.documentTypeId)
        })
        setSpinnerLoading(false)
    };
    const getUidByCode = (docId: number): string => {

        switch (docId) {
            case DOCUMENT_TYPES.NICVF: {
                return undefined != nicFrontUploadedList ? nicFrontUploadedList[0].uid : "0";
            }
            case DOCUMENT_TYPES.NICVR: {
                return undefined != nicRearUploadedList ? nicRearUploadedList[0].uid : "0";
            }
            case DOCUMENT_TYPES.PPV: {
                return undefined != passportAdminUploadedList ? passportAdminUploadedList[0].uid : "0";
            }
            case DOCUMENT_TYPES.PEP: {
                return undefined != pepUploadedList ? pepUploadedList[0].uid : "0";
            }
            default: {
                return "0";
            }
        }
    };
    const beforeUploadNicFront = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.NICVF);
    };

    const beforeUploadNicRear = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.NICVR);
    };
    const beforeUploadPassport = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PPV);
    };

    const beforeUploadPepDocument = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PEP);
    };

    const validateDocument = (file: any, type: DOCUMENT_TYPES) => {
        setSpinnerLoading(true)
        let allowedAllDocs = ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES);
        let indexOf = allowedAllDocs.indexOf(file.type);
        if (indexOf < 0) {
            message.error(MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 < uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);
        formData.append("jobNo", JSON.stringify(props.customerDetailWrapperDto.customerMstDto?.id));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId)
                setSpinnerLoading(false)
            } else {
                setSpinnerLoading(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    return (
        <div>
            <Spin spinning={isSpinnerLoading}>
                {isModalOpen &&
                    <CommonModalComp
                        modalProp={{isModalOpen: isModalOpen, title: documentName, docURL: docURL}}/>}
                <Form
                    className='form-input'
                    layout={"vertical"}
                    initialValues={{remember: true}}
                    form={form}
                    disabled={isCanDisableForm}
                >
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            {IDENTIFICATION_SOURCE.NIC === props.customerDetailWrapperDto.customerMstDto?.identificationSource?.sourceType ?
                                <div>
                                    <div>
                                        <Divider orientationMargin="0" className='upload-document-divider'
                                                 orientation="left">{IDENTIFICATION_SOURCE.NIC}</Divider>

                                    </div>
                                    <Row>
                                        <Col xxl={10} xl={14} lg={14} style={{marginRight: 20}}>
                                            <Form.Item
                                                name={"nicFrontDoc"}
                                                label=""
                                                getValueFromEvent={normFile}
                                                initialValue={nicFrontUploadedList && nicFrontUploadedList?.length > 0 ? [nicFrontUploadedList] : undefined}>
                                                <Upload
                                                    {...configs}
                                                    className='upload_comp'
                                                    fileList={nicFrontUploadedList && nicFrontUploadedList?.length > 0 ? nicFrontUploadedList : undefined}
                                                    listType="picture"
                                                    onPreview={(e: any) => openModal(undefined, nicFrontUploadedList ? nicFrontUploadedList[0] : undefined)}
                                                    onRemove={(e: any) => onRemove(e, DOC_CODE_NIC_VERIFICATION_FRONT_DOC, DOCUMENT_TYPES.NICVF)}
                                                    beforeUpload={beforeUploadNicFront}
                                                >
                                                    {(undefined != nicFrontUploadedList ? nicFrontUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{
                                                                            fontSize: 20,
                                                                            color: '#757575'
                                                                        }}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Front Image of the NIC From DRP {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={10} xl={14} lg={14}>
                                            <Form.Item
                                                name={"nicRearDoc"}
                                                label=""
                                                getValueFromEvent={normFile}
                                                initialValue={nicRearUploadedList && nicRearUploadedList?.length > 0 ? [nicRearUploadedList] : undefined}>
                                                <Upload
                                                    {...configs}
                                                    className='upload_comp'
                                                    fileList={nicRearUploadedList && nicRearUploadedList?.length > 0 ? nicRearUploadedList : undefined}
                                                    listType="picture"
                                                    onPreview={(e: any) => openModal(undefined, nicRearUploadedList ? nicRearUploadedList[0] : undefined)}
                                                    onRemove={(e: any) => onRemove(e, DOC_CODE_NIC_VERIFICATION_REAR_DOC, DOCUMENT_TYPES.NICVR)}
                                                    beforeUpload={beforeUploadNicRear}
                                                >
                                                    {(undefined != nicRearUploadedList ? nicRearUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{
                                                                            fontSize: 20,
                                                                            color: '#757575'
                                                                        }}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Rear Image of the NIC From DRP {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                                : IDENTIFICATION_SOURCE.PP === props.customerDetailWrapperDto.customerMstDto?.identificationSource?.sourceType ?

                                    <div>
                                        <div>
                                            <Divider orientationMargin="0" className='upload-document-divider'
                                                     orientation="left">{IDENTIFICATION_SOURCE.PP}</Divider>
                                            <Row>
                                                <Col xxl={10} xl={14} lg={14} style={{marginRight: 20}}>
                                                    <Form.Item
                                                        name={"passportDoc"}
                                                        label=""
                                                        getValueFromEvent={normFile}
                                                        initialValue={passportAdminUploadedList && passportAdminUploadedList?.length > 0 ? [passportAdminUploadedList] : undefined}>
                                                        <Upload
                                                            {...configs}
                                                            className='upload_comp'
                                                            fileList={passportAdminUploadedList && passportAdminUploadedList?.length > 0 ? passportAdminUploadedList : undefined}
                                                            listType="picture"
                                                            onPreview={(e: any) => openModal(undefined, passportAdminUploadedList ? passportAdminUploadedList[0] : undefined)}
                                                            onRemove={(e: any) => onRemove(e, DOC_CODE_PASSPORT_VERIFICATION_DOC, DOCUMENT_TYPES.PPV)}
                                                            beforeUpload={beforeUploadPassport}
                                                        >
                                                            {(undefined != passportAdminUploadedList ? passportAdminUploadedList.length : [].length) < 1 &&
                                                                <Button>
                                                                    <div className='upload-btn-div'>
                                                                        <div className="upload-icon-div">
                                                                            <PlusOutlined
                                                                                style={{
                                                                                    fontSize: 20,
                                                                                    color: '#757575'
                                                                                }}/>
                                                                        </div>
                                                                        <div
                                                                            className="upload-btn-text-div">
                                                                <span>
                                                                  Upload an Image of the Passport Detailed Page From DRP {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                        </div>
                                                                    </div>
                                                                </Button>
                                                            }
                                                        </Upload>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    : <></>}

                        </Col>
                    </Row>
                    <Row>
                        <Divider orientationMargin="0" className='upload-document-divider'
                                 orientation="left">Other Documents</Divider>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item>
                                {SELECT_OPTION.YES == props.customerDetailWrapperDto.adminWorkBasketDto?.politicallyExposedStatus ?
                                    <Tag icon={<CloseCircleOutlined/>} color="error"
                                         style={{marginBottom: 12}}>
                                        Politically exposed person
                                    </Tag>
                                    :
                                    <Tag icon={<CheckCircleOutlined/>} color="success"
                                         style={{marginBottom: 12}}>
                                        Politically not exposed person
                                    </Tag>
                                }
                            </Form.Item>
                            <Col xxl={10} xl={14} lg={14}>
                                <Form.Item
                                    name={"pepDoc"}
                                    label=""
                                    getValueFromEvent={normFile}
                                    initialValue={pepUploadedList && pepUploadedList?.length > 0 ? [pepUploadedList] : undefined}>
                                    <Upload
                                        {...configs}
                                        className='upload_comp'
                                        fileList={pepUploadedList && pepUploadedList?.length > 0 ? pepUploadedList : undefined}
                                        listType="picture"
                                        onRemove={(e: any) => onRemove(e, DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC, DOCUMENT_TYPES.PEP)}
                                        onPreview={(e: any) => openModal(undefined, pepUploadedList ? pepUploadedList[0] : undefined)}
                                        beforeUpload={beforeUploadPepDocument}
                                    >
                                        {(undefined != pepUploadedList ? pepUploadedList.length : [].length) < 1 &&
                                            <Button>
                                                <div className='upload-btn-div'>
                                                    <div className="upload-icon-div">
                                                        <PlusOutlined
                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                    </div>
                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Politically Exposed Status Document {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                    </div>
                                                </div>
                                            </Button>
                                        }
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </Col>
                    </Row>
                </Form>
            </Spin>

        </div>
    )
}
export default DetailsAndDocumentVerificationInformation